import { put, call, takeLatest, takeEvery, all } from 'redux-saga/effects';
import * as types from './types';
import * as api from './api';
import * as actions from './actions';
import { setInsuranceContract as setSprintContract } from 'subscriptions/sprint/actions';
import { setInsuranceContract as setBypassedContract } from 'subscriptions/bypassed/actions';
import { setInsuranceContract as setQuickContract } from 'subscriptions/quick/actions';

import { findGenerator, getAllGenerator, updateGenerator } from 'helpers/resourceSagas';

export const find = findGenerator({
  resourceType: 'insuranceContracts',
  endpoint: api.find
});

export const fetchFiltered = getAllGenerator({
  resourceType: 'insuranceContracts',
  endpoint: api.fetchFiltered,
  endpointArgs: (payload) => [ payload.params ],
});

export const activate = updateGenerator({
  resourceType: 'insuranceContracts',
  endpoint: api.activate,
  endpointArgs: ({ id }) => [ id ]
});

export const cancel = updateGenerator({
  resourceType: 'insuranceContracts',
  endpoint: api.cancel,
  endpointArgs: ({ id }) => [ id ],
  transformResponse: (resp) => [{}],
});

export function* create({ payload }) {
  const { attrs } = payload;
  try {
    yield put(actions.createPending());
    const resp = yield call(api.create, attrs);
    yield put(actions.createSucceeded(resp));
    const contract = resp.data;
    if (contract.subscription) {
      yield put(setSprintContract(contract.subscription, contract.id));
    }
    else if (contract.bypassed_subscription) {
      yield put(setBypassedContract(contract.bypassed_subscription, contract.id));
    }
    else if (contract.quick_subscription) {
      yield put(setQuickContract(contract.quick_subscription, contract.id));
    }
  }
  catch (err) {
    yield put(actions.createFailed(err));
  }
}

export function* watchFind() {
  yield takeEvery(types.FIND, find);
}

export function* watchFetchFiltered() {
  yield takeLatest(types.FETCH_FILTERED, fetchFiltered);
}

export function* watchActivate() {
  yield takeLatest(types.ACTIVATE, activate);
}

export function* watchCreate() {
  yield takeLatest(types.CREATE, create);
}

export function* watchCancel() {
  yield takeLatest(types.CANCEL, cancel);
}

export function* watchInsuranceContracts() {
  yield all([
    call(watchFind),
    call(watchFetchFiltered),
    call(watchCreate),
    call(watchActivate),
    call(watchCancel),
  ]);
}
